export default __webpack_public_path__ + "static/media/floor.18a41f4d.svg";